import { render, staticRenderFns } from "./smartup-iframe.vue?vue&type=template&id=46f629d5&scoped=true&"
import script from "./smartup-iframe.vue?vue&type=script&lang=js&"
export * from "./smartup-iframe.vue?vue&type=script&lang=js&"
import style0 from "./smartup-iframe.vue?vue&type=style&index=0&id=46f629d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f629d5",
  null
  
)

export default component.exports